import { PluginConfigType } from 'Core/PluginCore/PluginsManager'
import { Studio } from 'Core/Studio'
// @ts-ignore
import h2p from 'html2plaintext'
import { convertMarkdownToHTML } from 'Utils/markdown.util'
import { BasePlugin } from 'Core/PluginCore/BasePlugin'
import { PluginConnector } from 'Core/PluginCore/PluginConnector'
import { BlockStateFormatKey, ITaskBlock } from 'shared/express-interface/blocks-core/ITaskBlock'
import { Signal } from '@preact/signals-react'
import { ViolationSource } from 'shared/violations/types'

export type SoftRulesPluginConfigType = {
    word_count?: {
        minWordCount: number
        maxWordCount: number
    }
}
export class SoftRulesPlugin extends BasePlugin<PluginConfigType<SoftRulesPluginConfigType>> {
    public readonly id = 'Soft Rules'
    constructor(
        config: PluginConfigType<SoftRulesPluginConfigType>,
        pluginConnectors: PluginConnector[]
    ) {
        super(config, pluginConnectors)
    }

    public async initialize(studio: Studio) {
        this.studio = studio
        if (!this.config.config.word_count) return

        this.pluginConnectors.forEach(connector => {
            const data = connector.getData()
            const connectedBlocks = connector.getConnectedBlocks()
            if (data['text']) {
                data['text'].subscribe(() => {
                    this.handleEvent(connector.id, data, connectedBlocks)
                })
            }
        })
    }

    private async handleEvent(
        connectorId: string,
        data: Record<string, Signal<unknown> | null>,
        connectedBlocks: ITaskBlock[]
    ) {
        if (!data['text']) return
        const value = data['text'].value

        const text = h2p(
            data['text'].type === BlockStateFormatKey.Markdown
                ? convertMarkdownToHTML(value as string)
                : value
        ) as string
        const words = text.split(' ').filter(w => !!w.trim()).length
        this.handleViolation(connectorId, words)
        this.handleAnalysisItem(words, connectedBlocks)
    }

    private handleAnalysisItem(words: number, connectedBlocks: ITaskBlock[]) {
        connectedBlocks.forEach(block => {
            block.setTags?.(this.id, {
                label: 'Words',
                value: words.toString(),
                colorHex: '#000000',
            })
        })
    }

    private handleViolation(connectorId: string, words: number) {
        if (
            this.config.config.word_count?.minWordCount !== undefined &&
            words < this.config.config.word_count?.minWordCount
        ) {
            this.studio?.inputManager.addViolation?.({
                id: `${connectorId}_word_count`,
                type: 'error',
                message: `Word count is less than ${this.config.config.word_count?.minWordCount} words: ${words}`,
                source: ViolationSource.Plugin,
            })
        } else {
            this.studio?.inputManager.removeViolation?.(`${connectorId}_word_count`, 'error')
        }
        if (
            this.config.config.word_count?.maxWordCount !== undefined &&
            words > this.config.config.word_count?.maxWordCount
        ) {
            this.studio?.inputManager.addViolation?.({
                id: `${connectorId}_word_count`,
                type: 'warning',
                message: `Word count is more than ${this.config.config.word_count?.maxWordCount} words: ${words}`,
                source: ViolationSource.Plugin,
            })
        } else {
            this.studio?.inputManager.removeViolation?.(`${connectorId}_word_count`, 'warning')
        }
    }
}
